import * as BABYLON from 'babylonjs';
import PointEvents from '../Enumerations/ViewerEnums';
class PointCamera extends BABYLON.ArcRotateCamera {

    public events: EventTarget = new EventTarget();

    private _imageRotation: number = 0;
  
    constructor(name: string, public alpha: number, public beta: number, public radius: number, target: any, scene: BABYLON.Scene, imageRotation? : number) {
        super(name, alpha, beta, radius, target, scene);
        this.fov = .96;
        //this._imageRotation = imageRotation;
        this.getViewMatrix();
    }

    public getImageRotationMatrix() {
        if (this._imageRotation != 0) {
            var m = new BABYLON.Matrix();
            var rotQuat = BABYLON.Quaternion.RotationAxis(new BABYLON.Vector3(0, 1, 0), this._imageRotation);
            rotQuat.toRotationMatrix(m);
            return m;
        }
        else {
            return BABYLON.Matrix.Identity();
        }
    }

    public alignToVector(vector: BABYLON.Vector3) {
        const cameraRotMatrix = this.getImageRotationMatrix();

        const newDir = BABYLON.Vector3.TransformCoordinates(vector, cameraRotMatrix);
        const newPos = this.target.subtract(newDir.scale(this.radius));

        this._currentTarget = (this.target);
        this.setPosition(newPos);

        this._computeViewMatrix();
        this._getViewMatrix();
    }

    public getWorldDirection() {
        var cosa = Math.cos(this.alpha);
        var sina = Math.sin(this.alpha);
        var cosb = Math.cos(this.beta);
        var sinb = Math.sin(this.beta);

        var target = this._getTargetPosition();
        target.addToRef(new BABYLON.Vector3(this.radius * cosa * sinb, this.radius * cosb, this.radius * sina * sinb), this._newPosition);

        var cameraDirection = target.subtract(this.position).normalize();

        if (this._imageRotation != 0) {
            var m = new BABYLON.Matrix();
            var rotQuat = BABYLON.Quaternion.RotationAxis(new BABYLON.Vector3(0, -1, 0), this._imageRotation);
            rotQuat.toRotationMatrix(m);

            cameraDirection = BABYLON.Vector3.TransformCoordinates(cameraDirection, m);
        }

        return cameraDirection;
    }

    public getCameraDegrees() {
        var cosa = Math.cos(this.alpha);
        var sina = Math.sin(this.alpha);
        var cosb = Math.cos(this.beta);
        var sinb = Math.sin(this.beta);

        var target = this._getTargetPosition();
        target.addToRef(new BABYLON.Vector3(this.radius * cosa * sinb, this.radius * cosb, this.radius * sina * sinb), this._newPosition);

        var cameraDirection = target.subtract(this.position).normalize();

        if (this._imageRotation != 0) {
            var m = new BABYLON.Matrix();
            var rotQuat = BABYLON.Quaternion.RotationAxis(new BABYLON.Vector3(0, -1, 0), this._imageRotation);
            rotQuat.toRotationMatrix(m);

            cameraDirection = BABYLON.Vector3.TransformCoordinates(cameraDirection, m);
        }

        var directionVector = new BABYLON.Vector3(cameraDirection.x, 0, cameraDirection.z).normalize();

        var upDotProduct = BABYLON.Vector3.Dot(cameraDirection, directionVector);
        var directionDotProduct = BABYLON.Vector3.Dot(directionVector, new BABYLON.Vector3(0, 0, 1));
        upDotProduct = upDotProduct > 1 ? 1 : upDotProduct;
        directionDotProduct = directionDotProduct > 1 ? 1 : directionDotProduct;

        upDotProduct = upDotProduct > 1 ? 1 : upDotProduct;
        directionDotProduct = directionDotProduct > 1 ? 1 : directionDotProduct;

        var angleUp = Math.acos(upDotProduct);
        var angleFromNorth = Math.acos(directionDotProduct);

        // If the X is negative, then the rotation is 360 degrees MINUS the angle.
        angleFromNorth = directionVector.x < 0 ? 2 * Math.PI - angleFromNorth : angleFromNorth;

        var upAxis = Math.round(angleUp * 180 / (Math.PI)) == 0 ? "" : cameraDirection.y > 0 ? "U" : "D";

        var rotatedDegrees = Math.round(angleFromNorth * 180 / (Math.PI)) == 360 ? 0 : Math.round(angleFromNorth * 180 / (Math.PI));
        var upDegrees = angleUp * 180 / (Math.PI) > 89 ? 90 : Math.round(angleUp * 180 / (Math.PI));

        return { rotatedDegrees, upDegrees, upAxis };
    }

    protected _computeViewMatrix() {
        super._computeViewMatrix(this.position, this.target, this.upVector);
    }

    public _getViewMatrix(): BABYLON.Matrix {
        const viewMatrix = super._getViewMatrix();

        this.events?.dispatchEvent(new Event(PointEvents.Camera.CAMERA_CHANGED));

        return viewMatrix;
    }
}

export default PointCamera;